import React, { Component } from 'react';
import config from './../../../../config';
import { NoteClickToChart } from './ClickToChartImage.styled';

export default class ClickToChartImage extends Component<
   {
      id?: string;
   },
   {}
> {
   public shouldComponentUpdate() {
      return false;
   }

   public render() {
      const { id } = this.props;

      return <NoteClickToChart id={id ?? ''} src={`${config.baseName}/images/note-click-to-chart-V04.png`} alt='' width='150' height='100' />;
   }
}
